import { DetailHeader } from "../../components/detailHeader/DetailHeader";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { RecordContext } from "../../components/record/Record";
import { useContext } from "react";
import { format } from "date-fns";
import { renderFieldView } from "../../components/fieldsViews/renderFieldView";
import { findField } from "../../utils/findField";
import { OrderPurchaseNotes } from "./OrderPurchaseNotes";

export const OrderHeader = ({ actions }: { actions?: any }) => {
    const recordContext = useContext(RecordContext);

    if (!recordContext) return null;

    const treatmentNameField = findField(recordContext.formatedFields, "treatment");
    
    const payment_status = findField(recordContext.formatedFields, "payment_status");
    const payment_date = findField(recordContext.formatedFields, "payment_date");
    const payment_reminder_status = findField(recordContext.formatedFields, "payment_reminder_status");

    const userCreatedField = findField(recordContext.formatedFields, "user_created");


    return (
        <DetailHeader collection={recordContext.collection} actions={actions}>
            <Grid container spacing={10} alignItems="flex-start" xs={12}>
                <Grid xs={12} lg={6}>
                    <Typography variant="body1" color="primary">
                        Tratamento:
                    </Typography>
                    {treatmentNameField &&
                        renderFieldView(treatmentNameField, { treatment: recordContext.item.treatment }, "group")}
                </Grid>
                <Grid xs={12} lg={3}>
                    <Typography variant="body1" color="primary" mb={2}>
                        Data de Criação:
                    </Typography>
                    <Typography variant="body1">{format(new Date(recordContext.item.order_date), "yyyy-MM-dd HH:mm")}</Typography>
                </Grid>
                <Grid xs={12} lg={3}>
                    <Typography variant="body1" color="primary" mb={2}>
                        Clínica:
                    </Typography>
                    <Typography variant="body1">{recordContext.item.clinic?.name}</Typography>
                </Grid>
                <Grid xs={12} lg={4}>
                    <Typography variant="body1" color="primary" mb={1}>
                        {payment_status.headerName}:
                    </Typography>
                    {payment_status &&
                        renderFieldView(payment_status, { payment_status: recordContext.item.payment_status }, "group")}
                </Grid>
                {recordContext.item.payment_status === "paid" && recordContext?.item?.payment_date && (
                    <Grid xs={12} lg={3}>
                        <Typography variant="body1" color="primary" mb={2}>
                            {payment_date.headerName}:
                        </Typography>
                        <Typography variant="body1">{format(new Date(recordContext.item.payment_date), "yyyy-MM-dd")}</Typography>
                    </Grid>
                )}
                {recordContext.item.payment_status === "not_paid" && recordContext.item.payment_reminder_status && (
                    <Grid xs={12} lg={4}>
                        <Typography variant="body1" color="primary" mb={1}>
                            {payment_reminder_status.headerName}:
                        </Typography>
                        {payment_reminder_status &&
                            renderFieldView(
                                payment_reminder_status,
                                { payment_reminder_status: recordContext.item.payment_reminder_status },
                                "group"
                            )}
                    </Grid>
                )}

                <Grid xs={12} lg={4}>
                    <Typography variant="body1" color="primary" mb={1}>
                        Criado por:
                    </Typography>
                    {userCreatedField && renderFieldView(userCreatedField, recordContext.item, "group")}
                </Grid>
                <Grid xs={12} lg={4}>
                    <OrderPurchaseNotes
                        priceNotes={recordContext.item.treatment?.price_notes}
                        insuranceNumber={recordContext.item.treatment?.client?.insurance_number}
                    />
                </Grid>
            </Grid>
        </DetailHeader>
    );
};
